import $ from 'jquery'
import {Core} from './core'

export class TableContent {

  constructor() {
    if (Core.isAdmin()) return

    this.$document = $(document)
    this.$window = $(window)
    this.$tableContent = $('.table-content')
    this.$title = $('.table-content > p')
    this.$links = $('.table-content-list a')
    this.$body = $('body')

    this.handleScrollUpdateLinks()

    this.$window.on('scroll', this.handleScrollUpdateLinks.bind(this))
    this.$title.on('click', this.handleClickTitle.bind(this))
    this.$links.on('click', this.handleClickLink.bind(this))
  }

  handleScrollUpdateLinks() {
    if (this.$tableContent.length === 0) return

    let $links = this.$tableContent.find('a')

    if ($links.length === 0) return

    let $currentLink = false

    $links.each((index, link) => {
      let $link = $(link)
      let $item = $($link.attr('href'))

      if ($item.length === 0) return

      let itemTop = $item.offset().top
      let itemBottom = itemTop + $item.outerHeight()
      let windowTop = this.$window.scrollTop() + $('.header').outerHeight() + 50

      if (windowTop > itemTop && windowTop < itemBottom) {
        $currentLink = $link
      }
    })

    if (!$currentLink) return

    $links.removeClass('active')
    $currentLink.addClass('active')
  }

  handleClickTitle(e) {
    this.$tableContent.toggleClass('active')
  }

  handleClickLink(e) {
    this.$tableContent.removeClass('active')
  }
}
